document.addEventListener('DOMContentLoaded', function () {
  var teaser = document.querySelector('.opendots2-pink-launch-teaser');
  if (!teaser) return;
  if (
    document.body.classList.contains('template-suffix-opendots2-pink-launch') ||
    window.location.pathname.indexOf('/pages/opendots-2-purrfect-pink-launch') !== -1
  ) {
    teaser.classList.add('is-hidden');
    return;
  }
  if (window.sessionStorage.getItem('opendots2-pink-launch-teaser-closed') === '1') {
    teaser.classList.add('is-hidden');
    return;
  }

  var closeBtn = teaser.querySelector('.opendots2-pink-launch-teaser__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      teaser.classList.add('is-hidden');
      window.sessionStorage.setItem('opendots2-pink-launch-teaser-closed', '1');
    });
  }

  var link = teaser.querySelector('.opendots2-pink-launch-teaser__link');
  if (link) {
    link.addEventListener('click', function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: 'select_content',
        event_parameters: {
          content_type: 'teaser',
          content_name: link.getAttribute('data-ga-title') || '',
          button_name: (link.textContent || '').trim(),
        },
      });
    });
  }
});
